import { isValid, parse } from 'date-fns';
import type { DateRange } from '@data/components/report/ReportFilterBar/dropdowns/DateRangeDropdown/DateRangeDropdown';
import { getSchoolYearDateRange } from '@data/utils/get-school-year';

/** The format `from` and `to` take on the URL. */
export const DATE_PARAM_FORMAT = 'yyyy-MM-dd';

/**
 * Resolve the date range from the URL (`from`/`to` as yyyy-MM-dd) so a range
 * carried over from a drill-down survives refreshes and shared links. Falls
 * back to the current school year when the params are absent, unparseable, or
 * inverted (`from` after `to`) — e.g. on the base overview after navigating
 * back from a drill-down, where the params are dropped.
 */
export function resolveDateRange(
  from: string | null,
  to: string | null
): DateRange {
  if (from && to) {
    const fromDate = parse(from, DATE_PARAM_FORMAT, new Date());
    const toDate = parse(to, DATE_PARAM_FORMAT, new Date());
    if (isValid(fromDate) && isValid(toDate) && fromDate <= toDate) {
      return { from: fromDate, to: toDate };
    }
  }
  return getSchoolYearDateRange();
}
